import { render, staticRenderFns } from "./ProductContentChaptersContentList.vue?vue&type=template&id=54e050f5&scoped=true&"
import script from "./ProductContentChaptersContentList.vue?vue&type=script&lang=js&"
export * from "./ProductContentChaptersContentList.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentChaptersContentList.vue?vue&type=style&index=0&id=54e050f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e050f5",
  null
  
)

export default component.exports